import {CanDeactivateFn, Router} from '@angular/router';
import {CanComponentDeactivate} from '../Interfaces/unsaved-changes.interface';
import {inject} from '@angular/core';
import {ConfirmDialogService} from '../Services/confirm-dialog.service';
import {BsToastService} from '../Services/bs-toast-service';

export const UnsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate) => {
  const confirmDialogService = inject(ConfirmDialogService);
  const toastService = inject(BsToastService);
  const router = inject(Router);

  // If component has no changes, or directed to login allow navigation immediately
  try {
    // console.log('from guard: ' + router.getCurrentNavigation().finalUrl.toString());
    if (!component.checkForChanges() || router.getCurrentNavigation().finalUrl.toString().toLowerCase().includes('login')) {
      return true;
    }
  } catch {
    // If component check throws (e.g., not fully initialized), assume no changes
    return true;
  }

  // If changes exist, show dialog and return a Promise that resolves with the user's choice
  return new Promise<boolean>((resolve) => {
    const messages: string[] = ['There are unsaved changes. Do you really want to leave?'];
    confirmDialogService.confirmThis(
      messages,
      () => {
        // User confirmed navigation
        resolve(true);
      },
      () => {
        // User canceled navigation — stay on page, keep original snapshot intact
        toastService.showSuccessToast('Leave Canceled');
        resolve(false);
      }
    );
  });
};




